import { ChangeDetectorRef } from '@angular/core';

export function runDetachedUpdate(changeDetectorRef: ChangeDetectorRef, update: () => void): void {
  changeDetectorRef.detach();
  try {
    update();
  } finally {
    changeDetectorRef.reattach();
    changeDetectorRef.markForCheck();
  }
}
